



























import { Component, Mixins, Prop } from "vue-property-decorator";
import { RequestSheetTabMixin } from "./mixins";
// import { ButtonInfo } from "../../../../domain/workflow/items";
import { ReferenceFileViewMixin } from "../../../document/mixins";
import ReferenceFileSelectDialog from "../../../document/editor/dialogs/ReferenceFileSelectDialog.vue";
import { PdfStyleDrawableMixin } from "../../../system/mixins";

import PdfViewer from "../../../system/viewers/PdfViewer.vue";

@Component({
  components: {
    PdfViewer,
    ReferenceFileSelectDialog,
  }
})
export default class RequestSheetTab extends Mixins(RequestSheetTabMixin, PdfStyleDrawableMixin, ReferenceFileViewMixin) {
  $refs!: {
    referenceFileSelectDialog: ReferenceFileSelectDialog,
  };

  @Prop({default: true})
  showPreview: boolean;

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  showReferenceFiles(): void {
    if (this.reference.requestSheetReferenceFiles.length === 1) {
      this.openReferenceFileViewer(this.reference.requestSheetReferenceFiles[0]);
    } else {
      this.$refs.referenceFileSelectDialog.show(this.reference.requestSheetReferenceFiles, f => this.openReferenceFileViewer(f));
    }
  }
}
